import { gql } from 'react-apollo';

export const createChurch = gql`
  mutation createChurch($input: CreateChurchInput!) {
    createChurch(input: $input) {
      church {
        id
        code
        seniorPastor: senior_pastor {
          id
          email
        }
        pastors {
          edges {
            node {
              email
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/mutations/createChurch.js